exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".create-new-user .custom-select-select label {\n  color: #777777; }\n\n.create-new-user .custom-select-select > div::after {\n  border-bottom: 2px solid #777777 !important; }\n\n@media only screen and (max-width: 767px) {\n  .create-new-user .grid-item {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/clients/detail/users/add/index.scss
// module id = 1208
// module chunks = 0